var _classCallCheck = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/createClass");

var _get = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/get");

var _inherits = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:/VSCodeRepo/schatzkammer_web/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Declaration = require('../declaration');

var GridEnd = /*#__PURE__*/function (_Declaration) {
  "use strict";

  _inherits(GridEnd, _Declaration);

  var _super = _createSuper(GridEnd);

  function GridEnd() {
    _classCallCheck(this, GridEnd);

    return _super.apply(this, arguments);
  }

  _createClass(GridEnd, [{
    key: "insert",
    value:
    /**
     * Change repeating syntax for IE
     */
    function insert(decl, prefix, prefixes, result) {
      if (prefix !== '-ms-') return _get(_getPrototypeOf(GridEnd.prototype), "insert", this).call(this, decl, prefix, prefixes);
      var clonedDecl = this.clone(decl);
      var startProp = decl.prop.replace(/end$/, 'start');
      var spanProp = prefix + decl.prop.replace(/end$/, 'span');

      if (decl.parent.some(function (i) {
        return i.prop === spanProp;
      })) {
        return undefined;
      }

      clonedDecl.prop = spanProp;

      if (decl.value.includes('span')) {
        clonedDecl.value = decl.value.replace(/span\s/i, '');
      } else {
        var startDecl;
        decl.parent.walkDecls(startProp, function (d) {
          startDecl = d;
        });

        if (startDecl) {
          var value = Number(decl.value) - Number(startDecl.value) + '';
          clonedDecl.value = value;
        } else {
          decl.warn(result, "Can not prefix ".concat(decl.prop, " (").concat(startProp, " is not found)"));
        }
      }

      decl.cloneBefore(clonedDecl);
      return undefined;
    }
  }]);

  return GridEnd;
}(Declaration);

GridEnd.names = ['grid-row-end', 'grid-column-end'];
module.exports = GridEnd;